import { defineMessages } from 'react-intl'

export const lang = defineMessages({
  title: {
    id: 'donater.form.voice.select_modal.title',
    defaultMessage: 'Select a voice',
  },
  subtitle: {
    id: 'donater.form.voice.select_modal.subtitle',
    defaultMessage: 'Your message will be spoken by the selected voice.',
  },
  languageSelectTitle: {
    id: 'donater.form.voice.select_modal.language_select.title',
    defaultMessage: 'Language',
  },
})
